import React, { useState } from "react";
import { C, S } from "./styles";

// The Order Form terms shown before any paid action in Manage License
// (adding licenses, requesting an ACH bill, or reactivating a paid plan).
// Collapsed to ~3 lines by default (CSS line-clamp over the whole body, so
// wrapping is left to the browser rather than a hardcoded character count);
// "Show full agreement" removes the clamp. Read-only — the PO section is
// reproduced as given, not turned into input fields, since nothing here
// asked for that data to be captured.
function OrderAgreement({ onAccept, onBack, busy }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <button type="button" style={{ ...S.backLink, marginBottom: 12 }} onClick={onBack}>
        <i className="fa-solid fa-arrow-left" />
        Back
      </button>

      <h4 style={{ ...S.sectionHeading, marginBottom: 10 }}>Order Form Agreement</h4>

      <div style={expanded ? S.agreementScroll : undefined}>
        <div style={{ ...S.agreementBody, ...(expanded ? {} : S.agreementClamped) }}>
          <p style={S.agreementPara}>
            *If this Order Form is executed and/or returned to Athena Fintech by Customer after
            the Order Start Date above, Athena Fintech may adjust the Order Start Date and Order
            End Date, without increasing the Total Price, based on the date Athena Fintech
            activates the products and provided that the total term length does not change.
            Following activation, any adjustments to such Order Start Date and Order End Date may
            be confirmed by logging into Your Account, by reference to an order confirmation sent
            by Athena Fintech, and/or by contacting customer support.{" "}
            <strong>
              The Monthly/Unit Price shown above has been rounded to two decimal places for
              display purposes. As many as eight decimal places may be present in the actual
              price. The totals for this order were calculated using the actual price, rather
              than the Monthly/Unit Price displayed above, and are the true and binding totals
              for this order. Prices shown above do not include any taxes that may apply. Any
              such taxes are the responsibility of Customer. This is not an invoice. For
              customers based in the United States, any applicable taxes will be determined
              based on the laws and regulations of the taxing authority(ies) governing the "Ship
              To" location provided by Customer on this Order Form.
            </strong>
          </p>

          <p style={S.agreementSectionTitle}>Our Special Terms</p>
          <p style={S.agreementPara}>
            Any increase in subscription pricing (excluding support and resource-based Services)
            for the first renewal term will not exceed 5% over the then-current subscription
            pricing, provided that (a) Customer renews its entire then-current subscription
            volume under this Order Form combined with any associated add-on Order Forms, and
            (b) the first renewal term is the same duration as the Order Term of this Order Form
            or one year (whichever is longer). Thereafter, any increase in subscription and
            support pricing will be in accordance with Athena's pricing and policies in effect at
            the time of the renewal or as otherwise agreed to by the parties.
          </p>

          <p style={S.agreementSectionTitle}>Purchase Order Information</p>
          

          <p style={{ ...S.agreementPara, marginBottom: 0 }}>
            Signature by Customer and submission to Athena Fintech, this Order Form shall become
            legally binding unless this Order Form is rejected by Athena Fintech for any of the
            following reasons: (1) the signatory below does not have the authority to bind
            Customer to this Order Form, (2) changes have been made to this Order Form (other
            than completion of the purchase order information and the signature block), or (3)
            the requested purchase order information or signature is incomplete or does not match
            our records or the rest of this Order Form. Subscriptions are non-cancelable before
            their Order End Date. This Order Form is governed by the terms of the Athena Fintech
            MSA found at{" "}
            <a
              href="https://www.athenafintech.com/master-services-agreement"
              target="_blank"
              rel="noreferrer"
              style={{ color: C.primary }}
            >
              https://www.athenafintech.com/master-services-agreement
            </a>
            , unless (i) Customer has a written MSA executed by Athena Fintech for such services
            as referenced in the Documentation, in which case such written Athena Fintech MSA
            will govern or (ii) otherwise set forth herein. Additional information related to the
            Services may be found at{" "}
            <a
              href="https://athenafintech.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: C.primary }}
            >
              https://athenafintech.com
            </a>
            . For the avoidance of doubt, the applicable MSA takes precedence over any
            documentation.
          </p>
        </div>
      </div>

      <button
        type="button"
        style={S.agreementToggleBtn}
        onClick={() => setExpanded((v) => !v)}
      >
        <i className={expanded ? "fa-solid fa-chevron-up" : "fa-solid fa-chevron-down"} />
        {expanded ? "Show less" : "Show full agreement"}
      </button>

      <div style={{ display: "flex", gap: 10, marginTop: 20, flexWrap: "wrap" }}>
        <button
          type="button"
          style={{ ...S.btn, ...S.btnAuto, ...S.btnOutline }}
          disabled={busy}
          onClick={onBack}
        >
          Cancel
        </button>
        <button
          type="button"
          style={{ ...S.btn, ...S.btnAuto, ...S.btnPrimary }}
          disabled={busy}
          onClick={onAccept}
        >
          {busy ? "Please wait..." : "Accept"}
        </button>
      </div>
    </div>
  );
}

export default OrderAgreement;
